const env = process.env;
env.NODE_BUILD = process.env.VUE_APP_IS_LOCAL === 'true' ? 'false' : 'true';

const config = {};

config.IMAGE_STORAGE_PATH = config.IMAGE_HOST =
	'https://dn5hzapyfrpio.cloudfront.net';

if (env.NODE_ENV === 'development') {
	config.NODE_ENV = 'development';
	config.NODE_BUILD = env.NODE_BUILD;
	config.admin_js =
		'https://s143jlzole.execute-api.ap-northeast-2.amazonaws.com/dev';
	config.adminDomain = 'https://admin.glowpick.net';
	config.imgUrl = 'https://d2sogys4gzaamu.cloudfront.net/admin2/dev';
	config.adminImgUrl = 'https://d9vmi5fxk1gsw.cloudfront.net';
	config.gcId =
		'glowmee.com_0nmqqjeusns7oe3uldd9s3l7f0@group.calendar.google.com';
	config.gClientId =
		'883691140050-0ibito9le440u5eqftglidhqkfdt8o97.apps.googleusercontent.com';
	config.gcScope = 'https://www.googleapis.com/auth/calendar';
	config.gaKey = 'AIzaSyCVvKzrW8cWrZGBz-8TkjK9vXyY-76LQ1s';
	config.gaDiscoveryDocs =
		'https://www.googleapis.com/discovery/v1/apis/calendar/v3/rest';
	config.pushNowTerm = '3';
	config.pushReserveTerm = '30';
	config.lambdaApiDomain = 'https://api.lambda.glowpick.net';
	config.admin2Domain = 'https://admin.glowpick.net/admin2';
	config.adminEcDomain = 'https://ec.glowpick.net:8080';
	config.authDomain = 'https://auth.glowpick.net';
	config.apiJBaseURL = 'https://admin-api-j.glowpick.net';
	config.cookieDomain = '.glowpick.net';
	config.glowpickDomain = 'https://support-web.glowpick.net';
	config.TINYMCE_API_KEY = 'tb0jd7jrl225y3ez1q6t2vnilp3xkwyr0143oexu0ucq2djw';
} else {
	config.NODE_ENV = 'production';
	config.NODE_BUILD = env.NODE_BUILD;
	config.admin_js =
		'https://s143jlzole.execute-api.ap-northeast-2.amazonaws.com/production';
	config.adminDomain = 'https://admin.glowpick.com';
	config.imgUrl = 'https://d2sogys4gzaamu.cloudfront.net/admin2/prod';
	config.adminImgUrl = 'https://d9vmi5fxk1gsw.cloudfront.net';
	config.gcId = '';
	config.gClientId = '';
	config.gcScope = '';
	config.gaKey = '';
	config.gaDiscoveryDocs = '';
	config.pushNowTerm = '3';
	config.pushReserveTerm = '30';
	config.lambdaApiDomain = 'https://api.lambda.glowpick.com';
	config.admin2Domain = 'https://admin.glowpick.com/admin2';
	config.adminEcDomain = 'https://ec-admin.glowpick.com';
	config.authDomain = 'https://auth.glowpick.com';
	config.apiJBaseURL = 'https://admin-api-j.glowpick.com';
	config.cookieDomain = '.glowpick.com';
	config.glowpickDomain = 'https://www.glowpick.com';
	config.TINYMCE_API_KEY = '8dmkz28cd5ymbq8e0sgp7gx0e2a6wunu4kncnkx3hen4z2v2';
}
module.exports = config;

// 키값은 변경되지 않습니다
// 개발  계정키: 8dmkz28cd5ymbq8e0sgp7gx0e2a6wunu4kncnkx3hen4z2v2
// 마음님 계정키: kwgaefd9w1kidf4x4803g4ja6hk8f9i5scglpw9xbdkf4jcf
// 강표님 계정키: sj93vrmsiz0n0v4f13za4p69ic8wbanco4598c2r2txzdu4b
// 선주님 계정키: tb0jd7jrl225y3ez1q6t2vnilp3xkwyr0143oexu0ucq2djw
// 강표님 개인계정키: 8sjiltneueju3kv6rm87zxh2s9wc1aetheqahgs7tco50r1v
